import React from 'react'
import Main from '../components/Main';

const Tasks = () => <Main />

export default Tasks